/*
 * @Author: your name
 * @Date: 2020-12-28 16:44:14
 * @LastEditTime: 2020-12-28 17:53:26
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \vr-fornt-end\src\components\new\model\hotpoint_modal\hotpointModal.js
 */
import hotpointModal from '@/components/new/model/hotpoint_modal/HotPointModal.vue'
const myHotpointModal = {}
myHotpointModal.install = function (Vue) {
  const ModalConstructor = Vue.extend(hotpointModal)
  const instance = new ModalConstructor()
  instance.$mount(document.createElement('div'))
  document.body.appendChild(instance.$el)
  Vue.prototype.$hotpoint = {}
  Vue.prototype.$hotpoint.init = (width, height, info) => {
    // instance.width = width || '800px'
    // instance.height = height || '600px'
    // instance.info = info
    // instance.isShow = true
    instance.init(width, height, info)
  }
  Vue.prototype.$hotpoint.close = function () {
    instance.closeModal()
  }
  Vue.prototype.$hotpoint.mediaLen = async function () {
    return await instance.getMediaDuration()
  }
  Vue.prototype.$hotpoint.instance = instance
}

export default myHotpointModal
